import type { ReactNode } from 'react';
import './todo.css';

export interface TodoRowProps {
  /** "Your ID", "Ben's signature and ID" */
  title: ReactNode;
  /** One short line; may hold an <InlineLink> ("Send it again"). */
  status?: ReactNode;
  /** default = gold edge; warn = rejected upload; quiet = left out / waiting, no urgency. */
  tone?: 'default' | 'warn' | 'quiet';
  /** The row's one action. None = an info row (S12's "waits for your booking reference"). */
  action?: { label: ReactNode; onClick: () => void };
  /** Content of the box that opens under the row (S12's resend box); null/undefined = closed. */
  more?: ReactNode;
}

/** One open item on the claim page (S12): title, status line, one action. */
export function TodoRow({ title, status, tone = 'default', action, more }: TodoRowProps) {
  const cls = ['todo', tone !== 'default' && `todo--${tone}`, !action && 'todo--info']
    .filter(Boolean)
    .join(' ');
  return (
    <>
      <div className={cls}>
        <span>
          <span className="doc__t">{title}</span>
          {status && <span className="doc__s">{status}</span>}
        </span>
        {action && (
          <button type="button" className="todo__go" onClick={action.onClick}>
            {action.label}
          </button>
        )}
      </div>
      {more ? <div className="todo__more">{more}</div> : null}
    </>
  );
}
